<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <UserForm
      :form="form"
      :projects="projects"
      :organizations="organizations"
      :logged-user-type="loggedUserType"
      :can-select-project="canSelectProject"
      :submit="update"
    >
      <template #actions>
        <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/users">Go back</Link>
        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Save User</loading-button>
      </template>
    </UserForm>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import UserForm from "@/Pages/Users/UserForm.vue";

export default {
  components: {
    UserForm,
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  props: {
    user: Object,
    loggedUser: Object,
    organizations: Array,
    projects: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        type: this.user.type || null,
        organization_id: this.user.organization_id || null,
        photo: null,
        project_id: this.user.project_id || 38,
      }),
    }
  },
  computed: {
    loggedUserType() {
      return this.loggedUser.type
    },
    canSelectProject() {
      return this.loggedUser.type === 'ADMIN' ||
        (this.loggedUser.type === 'PARTNER' && this.user.type === 'TECHNICIAN')
    }
  },
  mounted() {
    console.log(this.user);
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  }
}
</script>
